import { useState, useMemo } from "react";
import { Search } from "lucide-react";
import { Breadcrumbs } from "../components/common";
import { Input } from "../components/ui/input";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS } from "../data/site";

export default function FAQ() {
  const [q, setQ] = useState("");
  const cats = useMemo(() => [...new Set(FAQS.map((f) => f.cat))], []);
  const filtered = useMemo(() => FAQS.filter((f) => f.q.toLowerCase().includes(q.toLowerCase()) || f.a.toLowerCase().includes(q.toLowerCase())), [q]);

  return (
    <>
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "FAQs" }]} />
      <section className="container-page py-12 lg:py-16">
        <span className="eyebrow">Frequently Asked Questions</span>
        <h1 className="mt-4 max-w-3xl font-heading text-[34px] font-800 leading-[1.1] text-brand-ink md:text-[52px]">Answers before you start a project.</h1>
        <div className="relative mt-8 max-w-xl">
          <Search className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-brand-muted" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search FAQs…" className="pl-12 h-12" data-testid="faq-search" />
        </div>
      </section>

      <section className="pb-24">
        <div className="container-page max-w-3xl">
          {filtered.length === 0 ? (
            <p className="rounded-xl border border-brand-border bg-white p-8 text-center text-brand-muted" data-testid="faq-empty">No questions match your search. Try a different term.</p>
          ) : (
            cats.map((cat) => {
              const items = filtered.filter((f) => f.cat === cat);
              if (!items.length) return null;
              return (
                <div key={cat} className="mb-8">
                  <h2 className="mb-2 font-heading text-[14px] font-700 uppercase tracking-wider text-brand-primary">{cat}</h2>
                  <Accordion type="single" collapsible>
                    {items.map((f, i) => (
                      <AccordionItem key={i} value={`${cat}-${i}`} className="border-brand-border">
                        <AccordionTrigger className="text-left font-heading text-[16px] font-600 text-brand-ink hover:no-underline">{f.q}</AccordionTrigger>
                        <AccordionContent className="text-[15px] leading-relaxed text-brand-muted">{f.a}</AccordionContent>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </div>
              );
            })
          )}
        </div>
      </section>
    </>
  );
}
